import { CALL_API } from '../constants/api';
import {
  GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS,
  GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST,
  GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE,
} from '../constants/constructor-recommendations';

/**
 * @param {*} recommendations
 * @returns {*}
 */
export function getConstructorRecommendationsSuccess(recommendations) {
  return {
    type: GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS,
    payload: {
      recommendations,
    },
  };
}

/**
 * @param {*} recommendations
 * @returns {*}
 */
export function getConstructorRecommendationsRequest(recommendations) {
  return {
    type: GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST,
    payload: {
      recommendations,
    },
  };
}

/**
 *
 * @param {*} details
 * @returns {*}
 */
export function getConstructorRecommendationsFailure(details) {
  return {
    type: GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE,
    payload: {
      details,
    },
  };
}

/**
 * Function to send over the product to be requested to the endpoint
 * @param {array} productId
 * @param {string} constructorPodId
 * @param {number} numberOfRecommendations
 * @returns {{type, payload: array}}
 */
export function getConstructorRecommendations(
  productId,
  constructorPodId,
  numberOfRecommendations
) {
  return {
    actions: {
      error: getConstructorRecommendationsFailure,
      start: getConstructorRecommendationsRequest,
      success: getConstructorRecommendationsSuccess,
    },
    method: 'get',
    type: CALL_API,
    url: `products/recommendation/${constructorPodId}?productId=${productId}&numResults=${numberOfRecommendations}`,
  };
}
